import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/694f318466cdef00144eb74e/bold_minimal_portfolio_1766797700062/src/app/not-found.tsx");
